export enum SocketEventEnum {
  // Message enums
  findAllMessages = 'findAllMessages',
  findOneMessage = 'findOneMessage',
  createMessage = 'createMessage',
  updateMessage = 'updateMessage',
  deleteMessage = 'deleteMessage',
  markAsSeen = 'markAsSeen',
  markAsDelivered = 'markAsDelivered',

  // Chat enums
  findOneChat = 'findOneChat',
  createChat = 'createChat',
  updateChat = 'updateChat',
  deleteChat = 'deleteChat',
  addMember = 'addMember',
  removeMember = 'removeMember',

  // on events
  NEW_MESSAGE = 'NEW_MESSAGE',
  NEW_CHAT = 'NEW_CHAT',
}
